module.exports = __webpack_public_path__ + "media/images/ASVH_header-1bd7c9d60137893f233e23a000c687cc.jpg";